<template>
  <div class="row p-1 mt-3 bg-white">
    <div class="row p-2">
        <div class="col" style="margin-left: 30px;">
            <a-dropdown>
                <template #overlay>
                    <a-menu @click="updateQueryDuration">
                        <a-menu-item key="LastThreeMonth">
                            <CalendarTwoTone />&nbsp;三個月內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="LastSixMonth">
                            <CalendarTwoTone />&nbsp;六個月內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="LastYear">
                            <CalendarTwoTone />&nbsp;一年內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="LastTwoYear">
                            <CalendarTwoTone />&nbsp;兩年內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="AllYears">
                            <CalendarTwoTone />&nbsp;所有已新增之專案
                        </a-menu-item>
                    </a-menu>
                </template>
                <a-button>
                    <CalendarTwoTone />{{ ProjectQueryDurationNames.get(reportForm.queryDuration) }}&nbsp;<DownOutlined />
                </a-button>
            </a-dropdown>
        </div>
    </div>
    <div class="row p-1">
      <div class="col-sm-6">
        <div class="chart">
          <canvas ref="projectStatusPieChartCanvas"></canvas>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="chart">
          <canvas ref="projectQuestPieChartCanvas"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { CalendarTwoTone, DownOutlined } from "@ant-design/icons-vue";
import { ProjectQueryDurationNames } from "@/common";
import { ref, reactive, onMounted } from "vue";

import Chart from "chart.js/auto";
import config from "@/config";
import common from "@/common";

var projectStatusPieChart = null;
var projectQuestPieChart = null;

const projectStatusPieChartCanvas = ref();
const projectQuestPieChartCanvas = ref();
const reportForm = reactive({});

const getApiRequestBody = () => {
    return {
        duration: reportForm.queryDuration
    };
}

const createProjectStatusPieChart = (pieChartData) => {
    const ctx = projectStatusPieChartCanvas.value.getContext("2d");
    projectStatusPieChart = new Chart(ctx, {
        type: "pie",
        data: pieChartData,
        options: {
            plugins: {
                legend: {
                    labels: {
                        font: {
                            size: 14
                        }
                    }
                },
                title: {
                  display: true,
                  text: "狀態類型",
                  font: {
                    size: 16
                  }
                }
            }
        }
    });
}

const createProjectQuestPieChart = (pieChartData) => {
    const ctx = projectQuestPieChartCanvas.value.getContext("2d");
    projectQuestPieChart = new Chart(ctx, {
        type: "pie",
        data: pieChartData,
        options: {
            plugins: {
                legend: {
                    labels: {
                        font: {
                            size: 14
                        }
                    }
                },
                title: {
                    display: true,
                    text: "問卷類型",
                    font: {
                        size: 16
                    }
                }
            }
        }
    });
}

const reloadData = () => {
    common.postRequest(config.projectInfoStatusChartData, getApiRequestBody(), (response) => {
        console.log("[Project-Status] Get PieChartData by QueryDuration: " + reportForm.queryDuration);
        if (projectStatusPieChart == null) {
            createProjectStatusPieChart(response.data);
        } else {
            projectStatusPieChart.data = response.data;
            projectStatusPieChart.update();
        }
    });
    common.postRequest(config.questTypeChartData, getApiRequestBody(), (response) => {
        console.log("[Quest-Type] Get PieChartData by QueryDuration: " + reportForm.queryDuration);
        if (projectQuestPieChart == null) {
            createProjectQuestPieChart(response.data);
        } else {
            projectQuestPieChart.data = response.data;
            projectQuestPieChart.update();
        }
    });
}

const updateQueryDuration = (menuItem) => {
    if (reportForm.queryDuration === menuItem.key) {
        return ;
    }
    reportForm.queryDuration = menuItem.key;
    common.saveQueryDuration(reportForm.queryDuration);
    reloadData();
}

onMounted(() => {
    reportForm.queryDuration = common.getQueryDuration("LastThreeMonth");
    reloadData();
});
</script>
<style scoped>
button,
span {
  display: inline-flex;
  align-items: center;
}
</style>
